export default "__VITE_ASSET__78d54424__"